import { useAppSelector } from 'redux-store/hooks/useAppSelector';
import { useAppDispatch } from 'redux-store/hooks/useAppDispatch';
import { HashtagMentionTypeEnum } from 'redux-store/api/activity-feed/hashtags.types';
import { clearHashtagMetadata } from 'redux-store/slices/hashtag-slice';
import { PhaseItemHashtagModal } from './phase-item-hashtag-modal';
import { SelectionHashtagModal } from './selection-hashtag-modal';
import { FileItemHashtagModal } from './file-item-hashtag-modal';

export const HashtagModals = () => {
  const dispatch = useAppDispatch();

  const hashtagType = useAppSelector((state) => state.hashtag.hashtagType);
  const projectId = useAppSelector((state) => state.hashtag.projectId);

  const isPhaseItem = hashtagType === HashtagMentionTypeEnum.phaseItem;
  const isFileItem = hashtagType === HashtagMentionTypeEnum.fileCabinetItem;
  const isSelectionItem = [
    HashtagMentionTypeEnum.selectionOption,
    HashtagMentionTypeEnum.selection,
  ].includes(hashtagType);

  const handleClose = () => {
    dispatch(clearHashtagMetadata());
  };

  if (!projectId) return null;

  return (
    <>
      {isPhaseItem && <PhaseItemHashtagModal projectId={projectId} onClose={handleClose} />}
      {isSelectionItem && <SelectionHashtagModal projectId={projectId} onClose={handleClose} />}
      {isFileItem && <FileItemHashtagModal projectId={projectId} onClose={handleClose} />}
    </>
  );
};
